import ClientDetailFullPage from '../../../../cm/Dashboard/FullPages/ClientDetail'


export default function ClientDetail({ children , id}) {
  return (    
      <ClientDetailFullPage id={id}>
        {children}
      </ClientDetailFullPage>   
  )
}